import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Announcement } from "../api.js";
import { SERVICE_IDS, LANGS } from "../constants.js";

export function AnnouncementsList() {
  const [service, setService] = useState("global");
  const [lang, setLang] = useState("ja");
  const [includeHidden, setIncludeHidden] = useState(false);
  const [items, setItems] = useState<Announcement[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      const r = await api.listAnnouncements({ service, lang, include_hidden: includeHidden, limit: 100 });
      setItems(r.items);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void load();
    // We intentionally don't depend on the setters — the user must press 絞り込む to apply.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section data-testid="announcements-list">
      <div className="toolbar" style={{ marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>お知らせ</h1>
        <Link to="/announcements/new" className="btn">+ 新規投稿</Link>
      </div>
      <form
        className="toolbar"
        onSubmit={(e) => {
          e.preventDefault();
          void load();
        }}
        style={{ marginBottom: 12 }}
      >
        <label>service<select value={service} onChange={(e) => setService(e.target.value)}>
          {SERVICE_IDS.map((s) => <option key={s} value={s}>{s}</option>)}
        </select></label>
        <label>lang<select value={lang} onChange={(e) => setLang(e.target.value)}>
          {LANGS.map((l) => <option key={l} value={l}>{l}</option>)}
        </select></label>
        <label>
          <input type="checkbox" checked={includeHidden} onChange={(e) => setIncludeHidden(e.target.checked)} />
          {" "}非表示も含める
        </label>
        <button type="submit" className="btn secondary">絞り込む</button>
      </form>
      {error && <div className="error-banner">{error}</div>}
      {loading ? <div className="empty-state">読み込み中…</div> : items.length === 0 ? (
        <div className="empty-state">該当するお知らせはありません</div>
      ) : (
        <table className="list" data-testid="announcements-table">
          <thead>
            <tr>
              <th>title</th>
              <th>service</th>
              <th>lang</th>
              <th>tags</th>
              <th>created</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id}>
                <td><Link to={`/announcements/${a.id}`}>{a.title}</Link></td>
                <td>{a.service_id}</td>
                <td>{a.lang}{a.source_id ? <span className="pill">翻訳</span> : null}</td>
                <td>{a.tags.map((t) => <span key={t} className="pill">{t}</span>)}</td>
                <td>{new Date(a.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
